import type { ComputerViewModelExtended } from './computer-view-model-extended';

export function computerIsInNetworkWithPersonalData(c: {
  computersInSameNetwork: ComputerViewModelExtended[];
}): boolean {
  const items = c.computersInSameNetwork.filter(function (item) {
    return item.personalDataItems.length > 0;
  });
  return items.length > 0;
}
